import { GraphiQL } from 'graphiql';
import React, { useCallback } from 'react';

import { makeAuthClient } from '@/bootstrap/okta';
import { Secure } from '@/components';
import 'graphiql/graphiql.css';

const createStorage = (namespace: string): Storage | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const storage = window.localStorage;
  return {
    clear: storage.clear,
    key: storage.key,
    length: storage.length,
    removeItem: (key: string) => storage.removeItem(`${namespace}.${key}`),
    getItem: (key: string) => storage.getItem(`${namespace}.${key}`),
    setItem: (key: string, value: string) =>
      storage.setItem(`${namespace}.${key}`, value),
  };
};

const storage = createStorage('bo-graphql');
const apiUrl = process.env.GATSBY_API_URL!;

const GraphQLEditorBlock = () => {
  const authService = makeAuthClient();

  const fetcher = useCallback(
    async (graphQLParams: any, options: any) => {
      const { accessToken } = await authService.tokenManager.getTokens();

      const data = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken?.accessToken || ''}`,
          ...options?.headers,
        },
        body: JSON.stringify(graphQLParams),
      });

      return data.json().catch(() => data.text());
    },
    [authService],
  );

  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <div style={{ minHeight: '100vh', height: '100vh' }}>
      <GraphiQL fetcher={fetcher} storage={storage} />
    </div>
  );
};

const Wrapper = () => (
  <Secure>
    <GraphQLEditorBlock />
  </Secure>
);

export default Wrapper;
